import nodeService from "./../../services/nodejs/index";
import {
  AUTH_REQUEST,
  AUTH_ERROR,
  AUTH_SUCCESS_CAKE,
  AUTH_SUCCESS_NODE,
  AUTH_LOGOUT,
  AUTH_LOGIN_REQUEST,
  AUTH_LOGIN_GOOGLE_REQUEST
} from "../actions/auth";

const state = {
  accessToken: "",
  user: {
    id: "",
    name: "",
    username: "",
    email: "",
    uuid: ""
  },
  params: {},
  place: {},
  roles: [],
  hasLoadedOnce: false
};

const getters = {
  isAuthenticated: state => !!state.accessToken,
  user: state => state.user,
  roles: state => state.roles,
  params: state => state.params,
  accessToken: state => state.accessToken
};

const actions = {
  [AUTH_LOGOUT]: ({ commit }) => {
    return new Promise(resolve => {
      commit(AUTH_LOGOUT)
      state.accessToken = ''
      resolve()
    });
  },
  [AUTH_LOGIN_REQUEST]: ({ commit }, payload) => {
    let errorObj = { error: "", message: "" };
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);
      nodeService
        .loginv2(payload.username, payload.password)
        .then(rspNode => {
          state.accessToken = rspNode.data.accessToken
          commit(AUTH_SUCCESS_NODE, rspNode)
          resolve(true)
        })
        .catch(err => {
          console.log("catch error", err)
          var StringError = String(err)
          errorObj.message = "usuario ou senha incorretos"
          if (StringError.includes("Network")) {
            errorObj.message = "Erro. Tente novamente mais tarde"
          }
          errorObj.error = err
          commit(AUTH_ERROR, err)
          reject(errorObj);
        });
    });
  },
  [AUTH_LOGIN_GOOGLE_REQUEST]: ({ commit }, payload) => {
    let errorObj = { error: "", message: "" };
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);
      nodeService
        .loginGoogle(payload.authCode, payload.pid)
        .then(rspNode => {
          resolve(true);
        })
        .catch(err => {
          var StringError = String(err);
          errorObj.message = "usuario ou senha incorretos";
          if (StringError.includes("Network")) {
            errorObj.message = "Erro. Tente novamente mais tarde";
          }
          errorObj.error = err;
          commit(AUTH_ERROR, err);
          reject(errorObj);
        });
    });
  }
};

const mutations = {
  [AUTH_REQUEST]: state => {
    state.status = "loading";
  },
  [AUTH_SUCCESS_NODE]: (state, resp) => {
    state.status = "success";
    state.accessToken = resp.data.accessToken;
    state.user.id = resp.data.id;
    state.user.uuid = resp.data.uuid;
    state.user.placeUuid = resp.data.place.uuid;
    state.user.name = resp.data.name;
    state.user.username = resp.data.username;
    state.user.email = resp.data.email;
    state.params = resp.data.params;
    state.roles = resp.data.rules
    state.hasLoadedOnce = true;
  },
  [AUTH_SUCCESS_CAKE]: (state, resp) => {
    state.accessToken = resp.data.accessToken;
  },
  [AUTH_ERROR]: state => {
    state.status = "error";
    state.hasLoadedOnce = true;
  },
  [AUTH_LOGOUT]: state => {
    state.accessToken = "";
    state.user = {};
    state.roles = [];
    state.params = {};
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
